<template>
  <div class="tw-flex tw-h-screen tw-items-center tw-justify-center">
    <ProgressSpinner />
  </div>
</template>

<script setup lang="ts">
import ProgressSpinner from './components/ProgressSpinner.vue'

const props = defineProps<{
  error: any
}>()

const errorMessage = computed(() => props.error.message || '')

const redirectMap: [RegExp, string][] = [
  [/page not found/i, '/error/page-not-found'],
  [/expiredinvite/i, '/error/expired-link'],
  [/invalidtoken/i, '/error/invalid-link'],
]
const target =
  redirectMap.find(([regex]) => regex.test(errorMessage.value))?.[1] || '/error/internal-error'
navigateTo(target)
</script>
